import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Crud } from '@awp/shared/Crud';

export const ModalButtons = {
  YES_NO: 0,
  OK_CANCEL: 1,
  OK_ONLY: 2,
};

const AwpMessageModal = ({ ...props }) => {
  const { showModal, setShowModal, primaryClick, actionId = null, buttonType = 0, title, body } = props;

  const crud = new Crud();

  const close = () => setShowModal(false);
  const primary = () => {
    if (primaryClick && primaryClick instanceof Function) primaryClick(actionId);
    close();
  };

  return (
    <Modal
      {...props}
      show={showModal}
      onHide={close}
      backdrop="static"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {title && <Modal.Header>{crud.getModalTitle({ title })}</Modal.Header>}
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={primary}>
          {buttonType === ModalButtons.YES_NO ? 'Yes' : 'Ok'}
        </Button>
        {buttonType === ModalButtons.OK_CANCEL || buttonType === ModalButtons.YES_NO ? (
          <Button variant="secondary" onClick={close}>
            {buttonType === ModalButtons.YES_NO ? 'No' : 'Cancel'}
          </Button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
};

AwpMessageModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  body: PropTypes.any.isRequired,
  buttonType: PropTypes.number.isRequired,
  primaryClick: PropTypes.func,
  title: PropTypes.string,
};

export default AwpMessageModal;
